/**
 * WEB-3447 — дверь ленивого куска вычисляемых значений (`computedValues.ts` с
 * `bodyMetrics.ts` и словами `bodyMetricsStrings.ts`: ИМТ, нормальный вес,
 * дата цели — `{{bmi}}` и др.). Решение владельца 16.10.2026 по WEB-3128:
 * «ленивые куски» вместо подъёма потолка веса первого экрана.
 *
 * Кусок нужен воронке, у которой в текстах есть имя вычисляемого значения
 * (`funnelUsesComputedValues`) — его ждёт страница (`usePlayerKitDoor`
 * в `PublicQuiz` и `PublicPaywall`), до первого кадра. Подстановка переменных
 * (`variable-context.ts`) читает кусок синхронно: на руках — считает, как
 * раньше; нет — пусто, как у любой незаполненной переменной (fail-open).
 *
 * Шкала ИМТ «из вычисления» ходит к `computedValues.ts` статически из своего
 * куска рендерера («reference», `ReferenceBlocksRenderer.tsx`) — тот кусок и
 * так ленивый и его ждёт дверь рендерера, отдельного ожидания ей не нужно.
 *
 * Кабинет кладёт кусок статически (`main.tsx`), тестовая обвязка — синхронным
 * добытчиком (`jest.setup.ts`).
 *
 * ГРАНИЦА. Признак «нужен» ищет `{{имя}}` в теле воронки целиком (все экраны,
 * встроенный пейволл, настройки) — по тому же правилу, по которому
 * подстановка находит переменную (`interpolate.ts`, имя обрезается от
 * пробелов). Страниц, которые подставляют переменные без этой двери
 * (страницы после оплаты), признак не видит: там `{{bmi}}` пуст, пока кусок
 * не приехал.
 */
import { COMPUTED_VARIABLE_NAMES } from './measureSources';

/*
 * WEB-3447, заход 3: свой файл и своя дверь у куска сняты — вычисляемые
 * значения едут в едином куске плеера (`playerKit.ts`, дверь
 * `playerKitDoor`); ждёт страница одной дверью (`usePlayerKitDoor.ts`).
 */

const USES_COMPUTED = new RegExp(
  `\\{\\{\\s*(?:${COMPUTED_VARIABLE_NAMES.join('|')})\\s*\\}\\}`,
);

/** В теле воронки есть `{{имя}}` вычисляемого значения. Не бросает. */
export function funnelUsesComputedValues(body: unknown): boolean {
  if (body === null || body === undefined) return false;
  try {
    return USES_COMPUTED.test(JSON.stringify(body) ?? '');
  } catch {
    return false;
  }
}
